module.exports = __webpack_public_path__ + "static/media/scrollable.d6718260.jpg";